import type { ReactElement } from 'react';
import { useServices, useSession } from '../../../app/di';
import { useObservable } from '../../../shared/store';
import { indicatorTasks } from './model/task-view';
import { TaskIndicator } from './TaskIndicator/TaskIndicator';
import { useTaskActions } from './use-task-actions';

/** TASK-UC-2: индикатор в шапке; задачи приходят по соединению событий (хранилище задач вкладки). */
export function TaskIndicatorConnected({ blogId, align }: { blogId: string | null; align: 'start' | 'end' }): ReactElement {
  const { tasks, session } = useServices();
  const { me } = useSession();
  const all = useObservable(tasks.tasks);
  const actions = useTaskActions();
  const isAdmin = session.isAdmin();
  return (
    <TaskIndicator
      tasks={indicatorTasks(all.values(), blogId, isAdmin)}
      blogId={blogId}
      timezone={me?.blogs.find((blog) => blog.id === blogId)?.timezone}
      isAdmin={isAdmin}
      align={align}
      canManage={actions.canManage}
      pendingId={actions.pendingId}
      onCancel={(task) => void actions.cancel(task)}
      onResume={(task) => void actions.resume(task)}
    />
  );
}
